import React, { memo } from 'react'
import { Maybe } from 'graphiql/dist/types'
import { Box } from 'transfix-ui/core'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { IAwardedLaneFragment } from '../../../graphql/AwardedLaneFragment'
import CarrierSalesRepSelector from './CarrierSalesRepSelector'
import { CopyDedicatedLaneUrl } from './CopyDedicatedLaneUrl'
import { SidebarListData } from './SidebarListData'
import SourceStatusSelector from './SourceStatusSelector'
import { useAwardDetails } from './hooks/useAwardDetails'
import { useRateMetrics } from './hooks/useRateMetrics'
import { useRmsDetails } from './hooks/useRmsDetails'

interface ISidebarProps {
  awardedLane?: Maybe<IAwardedLaneFragment>
  loading: boolean
}

export const Sidebar = memo<ISidebarProps>(({ awardedLane, loading }) => {
  const {
    carrierMarketRate,
    carrierSalesRep,
    datMiles,
    endDate,
    equipment,
    id: awardedLaneId,
    requestForProposalLaneFeedback,
    shipperLaneId,
    sourceStatus,
    startDate,
    weeklyVolume,
  } = awardedLane ?? {}

  const awardDetails = useAwardDetails({
    datMiles,
    endDate,
    equipment,
    startDate: startDate ?? '',
    weeklyVolume,
  })

  const rmsDetails = useRmsDetails({
    id: awardedLaneId,
    shipperLaneId,
  })

  const { getFlag } = useFeatureFlagContext()
  const { enabled: isDisplayStormUrl } = getFlag('stormUrlAwardedLanes')

  const rateMetrics = useRateMetrics({
    carrierMarketRate,
    requestForProposalLaneFeedback,
    isDisplayStormUrl,
  })

  return (
    <Box>
      <SourceStatusSelector
        loading={loading}
        awardedLaneId={awardedLaneId}
        sourceStatus={sourceStatus}
      />
      <br />
      <CarrierSalesRepSelector
        carrierSalesRep={carrierSalesRep}
        loading={loading}
        awardedLaneId={awardedLaneId}
      />
      <br />
      <SidebarListData canCopy label='Award Details' listData={awardDetails} loading={loading} />
      <br />
      <SidebarListData label='Rate Metrics' listData={rateMetrics} loading={loading} />
      <br />
      <SidebarListData label='RMS Details' listData={rmsDetails} loading={loading} />
      <br />
      {awardedLaneId && <CopyDedicatedLaneUrl awardedLaneId={awardedLaneId} />}
    </Box>
  )
})

export default Sidebar
